import { FC, ReactElement } from 'react'
import { useChannelPreviewInfo, useChannelStateContext, useChatContext } from 'stream-chat-react'

import { Avatar } from '@/components'
import { getDirectMessageTitle } from '@/helpers/directMessageTitle'

import './ConversationHeader.scss'

export const ConversationHeader: FC = (): ReactElement => {
    const { client } = useChatContext('ConversationHeader')
    const { channel } = useChannelStateContext('ConversationHeader')
    const { displayImage, displayTitle } = useChannelPreviewInfo({
        channel,
        overrideTitle: getDirectMessageTitle(channel, client.userID),
    })
    const isGroup = channel.type === 'team'
    const title = displayTitle ?? ''

    return (
        <header className="conversation-header">
            <Avatar
                className="conversation-header__avatar"
                icon={isGroup ? 'group' : undefined}
                image={displayImage}
                initials={isGroup ? undefined : title.charAt(0)}
                name={title}
            />
            <h1 className="conversation-header__title">{title}</h1>
        </header>
    )
}
